import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
}
/* Layout */
import Layout from '@/layout'
import ParentView from '@/components/ParentView'

/**
 * Note: 路由配置项
 *
 * hidden: true                   // 当设置 true 的时候该路由不会再侧边栏出现 如401，login等页面，或者如一些编辑页面/edit/1
 * alwaysShow: true               // 当你一个路由下面的 children 声明的路由大于1个时，自动会变成嵌套的模式--如组件页面
 *                                // 只有一个时，会将那个子路由当做根路由显示在侧边栏--如引导页面
 *                                // 若你想不管路由下面的 children 声明的个数都显示你的根路由
 *                                // 你可以设置 alwaysShow: true，这样它就会忽略之前定义的规则，一直显示根路由
 * redirect: noRedirect           // 当设置 noRedirect 的时候该路由在面包屑导航中不可被点击
 * name:'router-name'             // 设定路由的名字，一定要填写不然使用<keep-alive>时会出现各种问题
 * meta : {
    noCache: true                // 如果设置为true，则不会被 <keep-alive> 缓存(默认 false)
    title: 'title'               // 设置该路由在侧边栏和面包屑中展示的名字
    icon: 'svg-name'             // 设置该路由的图标，对应路径src/assets/icons/svg
    breadcrumb: false            // 如果设置为false，则不会在breadcrumb面包屑中显示
  }
 */

// 公共路由
export const constantRoutes = [{
  path: '/redirect',
  component: Layout,
  hidden: true,
  children: [{
    path: '/redirect/:path(.*)',
    component: (resolve) => require(['@/views/redirect'], resolve),
  }],
},
{
  path: '/login',
  component: (resolve) => require(['@/views/login'], resolve),
  hidden: true,
},
{
  path: '/404',
  component: (resolve) => require(['@/views/error/404'], resolve),
  hidden: true,
},
{
  path: '/401',
  component: (resolve) => require(['@/views/error/401'], resolve),
  hidden: true,
},
{
  path: '',
  component: Layout,
  redirect: 'index',
  children: [{
    path: 'index',
    component: (resolve) => require(['@/views/store/management/index'], resolve),
    name: '我的应用',
    meta: { title: '我的应用', icon: 'menu', noCache: true, affix: true },
  }],
},
{
  path: '',
  component: Layout,
  redirect: 'IdentityType',
  children: [{
    path: 'IdentityType',
    component: (resolve) => require(['@/views/system/user/IdentityType'], resolve),
    name: '身份类型',
    meta: { title: '身份类型', icon: '', noCache: true, affix: true },
  }],
  hidden: true,
},
{
  path: '/user',
  component: Layout,
  hidden: true,
  redirect: 'noredirect',
  children: [{
    path: 'profile',
    component: (resolve) => require(['@/views/system/user/profile/index'], resolve),
    name: 'Profile',
    meta: { title: '个人中心', icon: 'user' },
  }],
},
{
  path: '',
  component: Layout,
  hidden: true,
  children: [{
    path: '/management-detial',
    component: (resolve) => require(['@/views/store/management/management-detial'], resolve),
    name: 'managementDetial',
    meta: { title: '应用管理操作' },
  }],
},
{
  path: '/management',
  component: Layout,
  hidden: true,
  children: [{
    path: 'historyVersion',
    component: (resolve) => require(['@/views/store/management/history-version'], resolve),
    name: 'HistoryVersion',
    meta: { title: '历史版本' },
  }],
},
{
  path: '',
  component: Layout,
  hidden: true,
  children: [{
    path: '/management-detial-check',
    component: (resolve) => require(['@/views/store/management/management-detial-check'], resolve),
    name: 'managementDetialCheck',
    meta: { title: '应用详情' },
  }],
},
{
  path: '',
  component: Layout,
  hidden: true,
  children: [{
    path: '/change-mange',
    component: (resolve) => require(['@/views/store/management/change-mange'], resolve),
    name: 'changeMange',
    meta: { title: '渠道号应用' },
  }],
},
{
  path: '',
  component: Layout,
  hidden: true,
  children: [{
    path: '/channelApplication',
    component: (resolve) => require(['@/views/store/management/channelApplication'], resolve),
    name: 'channelApplication',
    meta: { title: '渠道号应用' },
  }],
},
{
  path: '',
  component: Layout,
  hidden: true,
  children: [{
    path: '/specified-vesion',
    component: (resolve) => require(['@/views/store/management/specified-vesion'], resolve),
    name: 'specifiedVesion',
    meta: { title: '指定版本' },
  }],
},
{
  path: '',
  component: Layout,
  hidden: true,
  children: [{
    path: '/specified-detail',
    component: (resolve) => require(['@/views/store/management/specified-detail'], resolve),
    name: 'specifiedDetail',
    meta: { title: '指定版本应用' },
  }],
},
{
  path: '',
  component: Layout,
  hidden: true,
  children: [{
    path: '/relyon-detail',
    component: (resolve) => require(['@/views/store/management/relyon-detail'], resolve),
    name: 'relyonDetail',
    meta: { title: '依赖包新增' },
  }],
},
{
  path: '',
  component: Layout,

  children: [{
    path: '/comments',
    component: (resolve) => require(['@/views/store/management/comments'], resolve),
    name: 'commentsManage',
    meta: { title: '评论管理', icon: 'documentation', noCache: true, affix: true },
  }],
}]

export default new Router({
  mode: 'hash', // 去掉url中的#
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes,
})
